import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getCurrencyISOCode} from "../../utils/get_currency";
import {IAmplitudeFavouriteOffer, IAmplitudeFavouriteProperty} from "../tracking/get_amplitude_favourites_event_properties";

interface IParams {
    offerId: number;
    propertyId?: number | null;
}

interface IResult {
    offer: IAmplitudeFavouriteOffer;
    property: IAmplitudeFavouriteProperty | null;
}

export const useFavouritesAmplitudeEntities = (params: IParams): IResult => {
    const {offerId, propertyId} = params;

    const propertyDetail = useSelector((state: IRPStore) => state.property.property);
    const offerDetail = useSelector((state: IRPStore) => state.offerDetail.offer);

    const propertyDetailOffer = propertyDetail?.offer;
    const property = propertyId != null && propertyDetail?.id === propertyId ? propertyDetail : null;
    const offer = propertyDetailOffer?.id === offerId ? propertyDetailOffer : offerDetail?.id === offerId ? offerDetail : null;

    const amplitudeProperty = property
        ? {
              id: property.id,
              number: property.number,
              area: property.area,
              rooms: property.rooms,
              floor: property.floor,
              price: property.price,
              pricePerSquareMeter: property.price_m2,
              currency: offer ? getCurrencyISOCode(offer.currency) : null
          }
        : propertyId != null
          ? {id: propertyId}
          : null;

    return {
        offer: {
            id: offerId,
            name: offer?.name,
            vendorName: offer?.vendor.name,
            address: offer?.address
        },
        property: amplitudeProperty
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getCurrencyISOCode} from "../../utils/get_currency";
import {IAmplitudeFavouriteOffer, IAmplitudeFavouriteProperty} from "../tracking/get_amplitude_favourites_event_properties";

interface IParams {
    offerId: number;
    propertyId?: number | null;
}

interface IResult {
    offer: IAmplitudeFavouriteOffer;
    property: IAmplitudeFavouriteProperty | null;
}

export const useFavouritesAmplitudeEntities = (params: IParams): IResult => {
    const {offerId, propertyId} = params;

    const propertyDetail = useSelector((state: IRPStore) => state.property.property);
    const offerDetail = useSelector((state: IRPStore) => state.offerDetail.offer);

    const propertyDetailOffer = propertyDetail?.offer;
    const property = propertyId != null && propertyDetail?.id === propertyId ? propertyDetail : null;
    const offer = propertyDetailOffer?.id === offerId ? propertyDetailOffer : offerDetail?.id === offerId ? offerDetail : null;

    const amplitudeProperty = property
        ? {
              id: property.id,
              number: property.number,
              area: property.area,
              rooms: property.rooms,
              floor: property.floor,
              price: property.price,
              pricePerSquareMeter: property.price_m2,
              currency: offer ? getCurrencyISOCode(offer.currency) : null
          }
        : propertyId != null
          ? {id: propertyId}
          : null;

    return {
        offer: {
            id: offerId,
            name: offer?.name,
            vendorName: offer?.vendor.name,
            address: offer?.address
        },
        property: amplitudeProperty
    };
};
